import * as React from "react"
import { MainNav } from "@/components/MainNav"
import { FlashMessages } from "@/components/FlashMessages"

export function AppShell({
  children,
  wide = false,
}: {
  children: React.ReactNode
  /** Opt into a wider main column for pages with side-by-side layouts. */
  wide?: boolean
}) {
  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav />
      <main className="min-w-0 flex-1 px-6 py-8 sm:px-10">
        {/* print:max-w-none — the print block resets main and .print-sheet,
            but this wrapper sat between them and silently capped tabloid
            documents at 56rem (9.3in of a 16in page). */}
        <div
          className={
            wide ? "mx-auto max-w-7xl print:max-w-none" : "mx-auto max-w-4xl print:max-w-none"
          }
        >
          <FlashMessages />
          {children}
        </div>
      </main>
    </div>
  )
}
